import { MAIN_COLOR } from 'shared/consts/styleValues';
import { styled, css } from 'styled-components';

interface Image {
	height?: string;
}

interface Button {
	$primary?: boolean;
	$padding?: string;
	$background?: string;
	$width?: string;
	$height?: string;
	$hide?: boolean;
  $margin?: string;
}

export const Button = styled.button<Button>`
	height: ${props => props.$height || '40px'};
	width: ${props => props.$width || '40px'};
	padding: ${props => props.$padding || '7px'};
	border-radius: 100%;
  margin: ${props => props.$margin || '0px'};

	display: flex;
	justify-content: center;
	align-items: center;

	background-color: ${props => props.$background || 'transparent'};

	${props =>
		props.$primary &&
		css`
			background-color: ${MAIN_COLOR};
			border: none;
		`};

	${props =>
		props.$hide &&
		css`
			display: none;
		`};

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Image = styled.img<{ height?: string }>`
	height: ${props => props.height || 'initial'};
`;
